import { z } from "zod";
import { CLAVES } from "../sat/catalogos.js";
const monto = z.string().regex(/^\d+(\.\d{1,6})?$/, "monto inválido");
/**
 * Complemento de Pagos 2.0.
 *
 * Cada pago recibido contra una factura PPD exige su propio CFDI tipo "P".
 * Un solo pago puede cubrir varias facturas (documentos relacionados), y una
 * factura puede recibir varios pagos parciales. De ahí la tabla intermedia.
 *
 * El cliente solo manda qué factura y cuánto se pagó de ella. NumParcialidad,
 * ImpSaldoAnt e ImpSaldoInsoluto son aritmética fiscal derivada del saldo
 * real de la factura en el momento del alta —no algo que el navegador pueda
 * saber con certeza, y mucho menos algo en lo que convenga confiar si lo
 * manda—: el backend los calcula con el saldo bloqueado en transacción.
 */
export const documentoPagoInputSchema = z.object({
    facturaId: z.uuid(),
    impPagado: monto,
});
export const pagoCreateSchema = z
    .object({
    clienteId: z.uuid(),
    fechaPago: z.iso.datetime({ local: true }),
    formaPago: z.enum(CLAVES.formaPago),
    moneda: z.enum(CLAVES.moneda).default("MXN"),
    tipoCambio: monto.optional(),
    monto: monto,
    numOperacion: z.string().max(100).optional(),
    rfcEmisorCtaOrd: z.string().max(13).optional(),
    ctaOrdenante: z.string().max(50).optional(),
    rfcEmisorCtaBen: z.string().max(13).optional(),
    ctaBeneficiario: z.string().max(50).optional(),
    documentos: z
        .array(documentoPagoInputSchema)
        .min(1, "el pago debe aplicarse a al menos una factura"),
})
    .superRefine((p, ctx) => {
    if (p.formaPago === "99") {
        ctx.addIssue({
            code: "custom",
            path: ["formaPago"],
            message: "Un pago real no puede tener forma de pago 99 (Por definir)",
        });
    }
    const suma = p.documentos.reduce((acc, d) => acc + Number(d.impPagado), 0);
    if (Math.abs(suma - Number(p.monto)) > 0.01) {
        ctx.addIssue({
            code: "custom",
            path: ["documentos"],
            message: `Lo aplicado (${suma.toFixed(2)}) no cuadra con el monto del pago (${p.monto})`,
        });
    }
    const facturaIds = new Set();
    for (const [i, d] of p.documentos.entries()) {
        if (facturaIds.has(d.facturaId)) {
            ctx.addIssue({
                code: "custom",
                path: ["documentos", i, "facturaId"],
                message: "Esta factura ya aparece antes en el mismo pago",
            });
        }
        facturaIds.add(d.facturaId);
        if (Number(d.impPagado) <= 0) {
            ctx.addIssue({
                code: "custom",
                path: ["documentos", i, "impPagado"],
                message: "El monto aplicado debe ser mayor a cero",
            });
        }
    }
});
export const listaPagosQuerySchema = z.object({
    clienteId: z.uuid().optional(),
    facturaId: z.uuid().optional(),
    desde: z.iso.date().optional(),
    hasta: z.iso.date().optional(),
    limite: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
//# sourceMappingURL=pago.js.map